import React from 'react';
import Head from 'next/head';
import { usePageContext } from 'Context/PageContext';
export const HeadInfos = () => {
  const pageContext = usePageContext();
  return (
    <Head>
      <title key="title">{pageContext.pageTitle}</title>
      <meta key="description" name="description" content={pageContext.pageDescription || ''} />
      <link key="canonical" rel="canonical" href={pageContext.canonicalUrl} />
      <meta
        key="viewport"
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      />
      {/* Safari iOS rewrites phone numbers into tel: links before React hydrates,
          which makes the client tree differ from the server HTML. */}
      <meta key="format-detection" name="format-detection" content="telephone=no" />
    </Head>
  );
};
